import i18n from "@/zapi-frontend/shared/i18n";

export function formatPortfolioDate(iso?: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(i18n.language, { month: "short", day: "numeric", year: "numeric" });
}
